import { MdDownloadForOffline } from 'react-icons/md'
import {Link, useParams } from 'react-router-dom';
import { v4 as uuidv4} from 'uuid';
import { client, urlFor } from '../client';
import MasonryLayout from './MasonryLayout';
import { pinDetailMorePinQuery, pinDetailQuery} from '../utils/data';
import Spinner from './Spinner';
import { useState, useEffect } from 'react';
import { IoMdHeartEmpty } from 'react-icons/io';

const PinDetail = ({user}) => {
    const [pins, setPins] = useState(null);
    const [pinDetail, setPinDetail] = useState(null);
    const [comment, setComment] = useState('');
    const [addingComment, setAddingComment] = useState(false);
    const [loading, setLoading] = useState(false);
    const { pinId } = useParams();

    const addComment = () => {
        if(comment){
            setAddingComment(true);
            client
              .patch(pinId)
              .setIfMissing({ comments: []})
              .insert('after', 'comments[-1]', [{
                  comment,
                  _key : uuidv4(),
                  postedBy: {
                      _type: 'postedBy',
                      _ref: user._id
                  }
                }]).commit()
                .then(() => {
                    fetchPinDetails();
                    setComment('')
                    setAddingComment(false)
                }).catch(err =>{
                    console.log(err)
                    setComment('')
                    setAddingComment(false)
                } );
        }
    }

    const fetchPinDetails = () => {
        let query = pinDetailQuery(pinId);

        if(query){
            setLoading(true);
            client.fetch(query)
              .then(data => {
                setPinDetail(data[0]);
                if(data[0]){
                    query = pinDetailMorePinQuery(data[0]);
    
                    client.fetch(query)
                      .then(res => setPins(res));
                  }
                  setLoading(false);
              })
        }else{
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchPinDetails();
    }, [pinId]);

    if(!pinDetail) return <Spinner message={"Loading pins..."}/>

    return (
        <>
        <div className="flex xl:flex-row flex-col m-auto bg-white"
          style={{ maxWidth: '1500px', borderRadius: '32px'}}>
           <div className="flex justify-center items-center md:items-start">
               <img src={pinDetail?.image && urlFor(pinDetail.image).url()} alt=""
                    className='rounded-t-3xl rounded-b-lg' alt='user post'
                />
           </div>
           <div className="w-full p-5 flex-1 xl:min-w-620">
                <div className="flex items-center justify-between">
                    <div className="flex gap-2 items-center">
                        <a href={`${pinDetail.image?.asset?.url}?dl=`} download 
                            onClick={(e) => e.stopPropagation()}
                            className="bg-white w-9 h-9 rounded-full flex items-center justify-center text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none"
                            >
                                <MdDownloadForOffline />
                        </a>
                    </div>
                    <a href={pinDetail.destination} target="_blank" rel='noreferrer'
                    >
                        {pinDetail.destination}
                    </a>
                </div>
                <div className="">
                    <h1 className='text-4xl font-bold break-word mt-3'>
                        {pinDetail.title}
                    </h1>
                    <p className='mt-3'>{pinDetail.about}</p>
                </div>
                <Link to={`/user-profile/${pinDetail.postedBy?._id}`} className="flex gap-2 mt-5 items-center bg-white rounded-lg">
                  <img src={pinDetail.postedBy?.image} alt="user image"
                  className="w-8 h-8 rounded-full object-cover"
                   />
                   <p className="font-semibold capitalize">
                       {pinDetail.postedBy?.username } 
                   </p>
                </Link>
                <h2 className='mt-5 text-2xl'>Comments</h2>
                <div className="max-h-370 overflow-y-auto">
                    {pinDetail?.comments?.map((comment, i) => (
                        <div key={i} 
                        className="flex gap-2 mt-5 items-center bg-white rounded-lg">
                            <img src={comment.postedBy.image} alt=""
                            className='h-10 w-10 rounded-full cursor-pointer' />
                            <div className="flex flex-col">
                                <p className='font-bold'>
                                    {comment.postedBy.username}
                                </p>
                                <p>{comment.comment}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex flex-wrap mt-6 gap-3">
                <Link to={`/user-profile/${pinDetail.postedBy?._id}`} >
                  <img src={pinDetail.postedBy?.image} alt="user image"
                    className="w-10 h-10 rounded-full cursor-pointer"
                   />
                </Link>
                <input type="text" placeholder='Add a comment'
                    className='flex-1 border-gray-100 outline-none border-2 p-2 rounded-xl focus:border-gray-300' 
                    onChange={(e) => setComment(e.target.value)} value={comment}
                />
                <button className='bg-red-500 text-white rounded-full px-6 py-2 font-semibold font-base outline-none'
                type="button" onClick={addComment}
                >
                    {addingComment ? 'Posting the commment..' : 'Post' }    
                </button>
                </div>
           </div>
        </div>
        {(pins?.length > 0 || loading !== true)  ? (
            <>
            <h2 className='text-center font-bold text-2xl mt-8 mb-4'>
                More like this
            </h2>
              <MasonryLayout pins={pins} />
            </>
        ) : (
            <Spinner message='Loading more Pins' />
        )}
    </>
    )
}

export default PinDetail;